module.exports = __webpack_public_path__ + "img/nova-accent.fe0d14e4.png";